export default {
  "content": "<path d=\"M10.5.833h-5V2.5h5V.833zM7.167 11.667h1.666v-5H7.167v5zm6.691-5.508l1.184-1.184A9.211 9.211 0 0013.867 3.8l-1.184 1.184A7.468 7.468 0 008 3.334a7.5 7.5 0 00-7.5 7.5c0 4.141 3.35 7.5 7.5 7.5a7.495 7.495 0 005.858-12.175zM8 16.666a5.829 5.829 0 01-5.833-5.834A5.83 5.83 0 018 5a5.829 5.829 0 015.833 5.834A5.829 5.829 0 018 16.666z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "19",
    "fill": "#707070",
    "viewBox": "0 0 16 19"
  }
};